import axios from 'axios';
const { VUE_APP_SERVER_BASE_URL } = process.env;

const http = axios.create({
  baseURL: VUE_APP_SERVER_BASE_URL,
  timeout: 10000,
  headers: { 'Content-Type': 'application/json' },
});

http.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem('token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

http.interceptors.response.use(
  (res) => {
    return res.data;
  },
  (err) => {
    throw err.response.data;
  }
);

export default http;
